import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
import RWETabs from './RWETabs';
const {Text, Paragraph} = Typography;
const Content = Layout;

const ExploringNew = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3' style={{color: appColors['ColorX']}}>Exploring new perspectives on aging</Paragraph>
        <Layout style={{background: 'inherit', width: 'fit-content', display: 'block', marginTop: '-2%', textAlign: 'justify', textJustify: 'inter-word', marginLeft: '10%', marginRight: '10%'}}>
          <Text className='BaseText'><i>The BioTec CCM team grew for this competition, so it was important to generate activities where the entire team could meet to <b>reflect on the problem </b> we are addressing from a <b>social and scientific point of view.</b> We also shared some of these activities with members of our community to involve them in the fascinating field of the biology of aging. </i></Text>
        </Layout>
      </Content>
      <RWETabs/>
      <Divider/>
    </Layout>
  );
};

export default ExploringNew;
